import React, { useState } from "react";
import axios from "axios";
import { API } from "../shared/constants";
import { inputStyle, labelStyle, fieldStyle } from "../shared/styles";
import { SimpleModal } from "../shared/SimpleModal";

export function SiteContactModal({ siteId, onClose, onSave }) {
  const [contact, setContact] = useState({
    name: "",
    position: "",
    role: "primary",
    phone: "",
    mobile: "",
    email: "",
    notes: "",
    receives_reports: false,
    is_scheduling_contact: false,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const handleSave = async () => {
    if (!contact.name.trim()) {
      setError("Name is required.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await axios.post(`${API}/site-contacts/`, { ...contact, site: siteId });
      onSave();
      onClose();
    } catch (e) {
      setError("Something went wrong.");
      setSaving(false);
    }
  };
  return (
    <SimpleModal
      title="Add Site Contact"
      onClose={onClose}
      onSave={handleSave}
      saving={saving}
      error={error}
      wide
    >
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}
      >
        <div style={fieldStyle}>
          <label style={labelStyle}>Name *</label>
          <input
            style={inputStyle}
            value={contact.name}
            onChange={(e) => setContact({ ...contact, name: e.target.value })}
            placeholder="Full name"
          />
        </div>
        <div style={fieldStyle}>
          <label style={labelStyle}>Position</label>
          <input
            style={inputStyle}
            value={contact.position}
            onChange={(e) =>
              setContact({ ...contact, position: e.target.value })
            }
            placeholder="Job title"
          />
        </div>
        <div style={fieldStyle}>
          <label style={labelStyle}>Primary Role</label>
          <select
            style={inputStyle}
            value={contact.role}
            onChange={(e) => setContact({ ...contact, role: e.target.value })}
          >
            <option value="primary">Primary Contact</option>
            <option value="financial">Financial Control</option>
            <option value="reports">Reports Receiving</option>
            <option value="scheduling">Scheduling</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div style={fieldStyle}>
          <label style={labelStyle}>Phone</label>
          <input
            style={inputStyle}
            value={contact.phone}
            onChange={(e) => setContact({ ...contact, phone: e.target.value })}
            placeholder="Phone number"
          />
        </div>
        <div style={fieldStyle}>
          <label style={labelStyle}>Mobile</label>
          <input
            style={inputStyle}
            value={contact.mobile}
            onChange={(e) => setContact({ ...contact, mobile: e.target.value })}
            placeholder="Mobile number"
          />
        </div>
        <div style={fieldStyle}>
          <label style={labelStyle}>Email</label>
          <input
            style={inputStyle}
            value={contact.email}
            onChange={(e) => setContact({ ...contact, email: e.target.value })}
            placeholder="Email address"
          />
        </div>
      </div>
      <div style={fieldStyle}>
        <label style={labelStyle}>Notes</label>
        <textarea
          style={{ ...inputStyle, height: "70px", resize: "vertical" }}
          value={contact.notes}
          onChange={(e) => setContact({ ...contact, notes: e.target.value })}
          placeholder="Any notes..."
        />
      </div>
      <div style={{ display: "flex", gap: "16px" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "13px",
          }}
        >
          <input
            type="checkbox"
            checked={contact.receives_reports}
            onChange={(e) =>
              setContact({ ...contact, receives_reports: e.target.checked })
            }
          />
          Receives Reports
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "13px",
          }}
        >
          <input
            type="checkbox"
            checked={contact.is_scheduling_contact}
            onChange={(e) =>
              setContact({
                ...contact,
                is_scheduling_contact: e.target.checked,
              })
            }
          />
          Scheduling Contact
        </label>
      </div>
    </SimpleModal>
  );
}
